import moment from 'moment';

export const formatEventDate = startTime =>
    moment(startTime).format('dddd MMMM Do');

export const formatEventTime = (startTime, endTime) =>
    moment(startTime).format('HH:mm') + ' - ' + moment(endTime).format('HH:mm');
